import * as actionTypes from 'actions';

const initialState = {
    Loading: false,
    activitiesDropdownList:[],
    validation_error: "",
    redirect_to_list: false,
    showDeleteModel: false,
    showUpdateForm: false,
    showViewPage: false,
}

const ActivityReducer = (state =initialState , action) => {

    switch (action.type){

        case actionTypes.ACTIVITY_DROPDOWN_LIST_SUCCESS:
            return {
                ...state,
                Loading: false,
                activitiesDropdownList :action.activitiesDropdownList,
            }
            default:
                return state;
    }
}
export default ActivityReducer;